export default {"src":"/_next/static/media/escape_towns.9a06c0c1.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};